/* eslint-disable camelcase */
import * as debugActionsType from '@/constants/debugActionsType';

const initialState = {
  currentPCState: 'IDLE',
  flowRate: 0,
  finalVolume: 0,
  estimatedFinalConcentration: '0',
  diafiltrationMode: 'None',
  diaphragmVacuumPressure: 0,
  diaphragmPressure: 0,
  diaphragmTiming: 0,
  isPCRunning: false,
  isPriming: false,
  isConcentrating: false,
  isDiafiltrating: false,
  isPCPaused: false,
  showWarning: false,
  isAutoCalibrate: false,
  operatingPressure: 0,
  recoveryOfLiquid: 'Air',
  startingVolume: 100,
  startingConcentration: '0',
  valveTiming: 0,
  volumeToStartAt: '0',
  bufferVolumeToUse: '0',
  pressureTimeLimit: '0',
  percentageProgressBar: 0,
  estimateTime: 0,
  progressBarStatus: null,

  currentPressure: '24',
  pumpFlowRate: '73',
  currentVolume: '0',
  estimateConcentration: '999',
  estSecondsRemaining: '',
  secondsElapsed: '40',
  percentageComplete: '100',
  currentBuffer: '0',
  dummyBuffer: '0',
  dummyVolume: '22',
  isStopingFromButton: false,
  activeMenu: 'None',
  primeTiming: '20',
  // explorer
  profileList: null,
  profileSelected: 'null',
  profileName: 'No Profile',
  profileSettingExplorer: null,
  showProfile: null,
  lastProfileIdView: 0,
  profileAddress: null,

  // ALERT
  alertShow: false,
  alertText: '',
  alertStyle: 'alert-success',

  // hardware value
  pressureSource: -1,
  pressureBottle: -1,
  vacuumSource: -1,

  // message
  failureMessage: null,
  errorMessage: null,
  warningMessage: null,
  successMessage: null,
  clearMessage: false,

  getSetup: false,
  getSetupExt: false,
  getAdvanceSetting: false,
  getStatus: false,
  getOtherInfo: false,

  serialConnect: true,

  // sensor value
  updateSensorValue: false,

  // SEQUENCE DESIGNER
  startSequenceDesigner: false,
  stopSequenceDesigner: false,
  pauseSequenceDesigner: false,
  resumeSequenceDesigner: false,

  // other info
  FirmwareName: 'No Value',
  FirmwareVersion: null,
  SoftwareName: null,
  Version: null,
  Culture: null,
  PublicKeyToken: null,
  SoftwareVersion: null,
  HostName: null,
  IpAddress: null,
};

export default function debugStore(state = initialState, action = {}) {
  switch (action.type) {
    case debugActionsType.INIT_VALUE:
      if (action.value) {
        return {
          ...state,
          bufferVolumeToUse: action.value.bufferVolumeToUse,
          diafiltrationMode: action.value.diafiltrationMode,
          diaphragmPressure: action.value.diaphragmPressure,
          diaphragmTiming: action.value.diaphragmTiming,
          diaphragmVacuumPressure: action.value.diaphragmVacuumPressure,
          finalConcentration: action.value.finalConcentration,
          finalVolume: action.value.finalVolume,
          flowRate: action.value.flowRate,
          operatingPressure: action.value.operatingPressure,
          primeTiming: action.value.primeTiming,
          recoveryOfLiquid: action.value.recoveryOfLiquid,
          startingVolume: action.value.startingVolume,
          startingConcentration: action.value.startingConcentration,
          valveTiming: action.value.valveTiming,
          volumeToStartAt: action.value.volumeToStartAt,
          // currentVolume: action.value.currentVolume,
          // currentBuffer : action.value.currentBuffer,
          // dummyBuffer : action.value.dummyBuffer,
          dummyVolume: action.value.dummyVolume,
          pressureTimeLimit: action.value.pressureTimeLimit,

          // currentPCState :  action.value.currentPCState,
          // isPCRunning : action.value.isPCRunning,
          // isPCPaused : action.value.isPCPaused
        };
      }
      break;

    case debugActionsType.UPDATE_ALL_VALUE:
      if (action.value) {
        return {
          ...state,
          bufferVolumeToUse: action.value.bufferVolumeToUse,
          diafiltrationMode: action.value.diafiltrationMode,
          diaphragmPressure: action.value.diaphragmPressure,
          diaphragmTiming: action.value.diaphragmTiming,
          diaphragmVacuumPressure: action.value.diaphragmVacuumPressure,
          finalConcentration: action.value.finalConcentration,
          finalVolume: action.value.finalVolume,
          flowRate: action.value.flowRate,
          operatingPressure: action.value.operatingPressure,
          primeTiming: action.value.primeTiming,
          recoveryOfLiquid: action.value.recoveryOfLiquid,
          startingVolume: action.value.startingVolume,
          startingConcentration: action.value.startingConcentration,
          valveTiming: action.value.valveTiming,
          volumeToStartAt: action.value.volumeToStartAt,
          currentVolume: action.value.currentVolume,
          currentBuffer: action.value.currentBuffer,
          dummyBuffer: action.value.dummyBuffer,
          dummyVolume: action.value.dummyVolume,
        };
      }
      break;

    case debugActionsType.UPDATE_STARTING_VOLUME:
      if (action.value) {
        return {...state, startingVolume: action.value};
      }
      break;

    case debugActionsType.UPDATE_STARTING_CONCENTRATION:
      if (action.value) {
        return {...state, startingConcentration: action.value};
      }
      break;

    case debugActionsType.UPDATE_FINAL_VOLUME:
      if (action.value) {
        return {...state, finalVolume: action.value};
      }
      break;

    case debugActionsType.UPDATE_FINAL_CONCENTRATION:
      if (action.value) {
        return {...state, finalConcentration: action.value};
      }
      break;

    case debugActionsType.UPDATE_BUFER_VOLUME_TO_USE:
      if (action.value) {
        return {...state, bufferVolumeToUse: action.value};
      }
      break;

    case debugActionsType.UPDATE_VOLUME_TO_START_AT:
      if (action.value) {
        return {...state, volumeToStartAt: action.value};
      }
      break;

    case debugActionsType.UPDATE_DIAFILTRATION_MODE:
      if (action.value) {
        return {...state, diafiltrationMode: action.value};
      }
      break;

    case debugActionsType.RUN_PROTEIN_CONCENTRATOR:
      return {
        ...state,
        isPCRunning: action.value.isPCRunning,
        errorMessage: action.value.errorMessage,
      };

    case debugActionsType.PAUSE_PROTEIN_CONCENTRATOR:
      return {
        ...state,
        isPCPaused: action.value.isPCPaused,
        errorMessage: action.value.errorMessage,
      };

    case debugActionsType.RUN_PRIMING:
      return {...state, isPriming: action.value};

    case debugActionsType.RUN_CONCENTRATING:
      return {...state, isConcentrating: action.value};

    case debugActionsType.RUN_DIAFILTRATING:
      return {...state, isDiafiltrating: action.value};

    case debugActionsType.STOP_PROTEIN_CONCENTRATOR:
      return {
        ...state,
        isPCRunning: false,
        priming: true,
      };

    case debugActionsType.UPDATE_PC_STATE:
      if (action.value) {
        return {
          ...state,
          currentPCState: action.value,
        };
      }
      break;

    case debugActionsType.UPDATE_OPERATING_PRESURE:
      if (action.value) {
        return {...state, operatingPressure: action.value};
      }
      break;

    case debugActionsType.UPDATE_RECOVERY_OF_LIQUID: {
      if (action.value) {
        return {...state, recoveryOfLiquid: action.value};
      }
      break;
    }

    case debugActionsType.UPDATE_FLOW_RATE:
      if (action.value) {
        return {...state, flowRate: action.value};
      }
      break;

    // -------------------------------------------------
    // Advanced Setup
    // --------------------------------------------------
    // case debugActionsType.INIT_VALUE:
    //   if (action.value) {
    //     return {
    //       ...state,
    //       diaphragmVacuumPressure: action.value.diaphragmVacuumPressure,
    //       diaphragmPressure: action.value.diaphragmPressure,
    //       diaphragmTiming: action.value.diaphragmTiming,
    //       valveTiming: action.value.valveTiming,
    //     };
    //   }
    //   break;

    case debugActionsType.UPDATE_DIAPHRAGM_VACUUM_PRESSURE:
      if (action.value) {
        return {...state, diaphragmVacuumPressure: action.value};
      }
      break;

    case debugActionsType.UPDATE_DIAPHRAGM_PRESSURE:
      if (action.value) {
        return {...state, diaphragmPressure: action.value};
      }
      break;

    case debugActionsType.UPDATE_DIAPHRAGM_TIMING:
      if (action.value) {
        return {...state, diaphragmTiming: action.value};
      }
      break;

    case debugActionsType.UPDATE_VALVE_TIMING:
      if (action.value) {
        return {...state, valveTiming: action.value};
      }
      break;

    case debugActionsType.UPDATE_SHOW_WARNING:
      if (action.value) {
        const {showWarning, errorMessage} = action.value;

        return {
          ...state,
          showWarning,
          errorMessage: errorMessage !== undefined ? errorMessage : initialState.errorMessage,
        };
      }
      break;

    case debugActionsType.AUTO_CALIBRATE:
      if (action.value) {
        return {...state, autoCalibrate: action.value};
      }
      break;

    case debugActionsType.RESET_TO_DEFAULT:
      if (action.value) {
        return {
          ...state,
          diaphragmVacuumPressure: action.value.diaphragmVacuumPressure,
          diaphragmPressure: action.value.diaphragmPressure,
          diaphragmTiming: action.value.diaphragmTiming,
          valveTiming: action.value.valveTiming,
        };
      }
      break;
    // STATUS
    case debugActionsType.UPDATE_PERCENTAGE_PROGRESS_BAR:
      return {
        ...state,
        percentageProgressBar: action.value,
      };

    case debugActionsType.UPDATE_ESTIMATE_TIME:
      return {
        ...state,
        estimateTime: action.value,
      };

    case debugActionsType.UPDATE_PROGRESSBAR_STATUS:
      return {
        ...state,
        progressBarStatus: action.value,
      };

    case debugActionsType.UPDATE_STATUS:
      return {
        ...state,
        currentPressure: action.value.currentPressure,
        pumpFlowRate: action.value.pumpFlowRate,
        currentVolume: action.value.currentVolume,
        currentBuffer: action.value.currentBuffer,
        estimateConcentration: action.value.estimateConcentration,
        estSecondsRemaining: action.value.estSecondsRemaining,
        secondsElapsed: action.value.secondsElapsed,
        warningMessage: action.value.warningMessage,
        failureMessage: action.value.failureMessage,
      };

    case debugActionsType.UPDATE_CURRENT_VOLUME:
      return {...state, currentVolume: action.value};

    case debugActionsType.UPDATE_CURRENT_BUFFER:
      return {...state, currentBuffer: action.value};

    case debugActionsType.UPDATE_DUMMY_BUFFER:
      return {...state, dummyBuffer: action.value};

    case debugActionsType.UPDATE_STOPPING_FROM_BUTTON:
      return {...state, isStopingFromButton: action.value};

    case debugActionsType.UPDATE_ACTIVE_MENU:
      return {...state, activeMenu: action.value};

    // Explorer
    case debugActionsType.UPDATE_PROFILE_LIST:
      if (action.value) {
        return {...state, profileList: action.value};
      }
      break;
    case debugActionsType.PROFILE_SELECTED:
      if (action.value) {
        return {...state, profileSelected: action.value};
      }
      break;

    case debugActionsType.UPDATE_PROFILE_NAME:
      if (action.value) {
        return {...state, profileName: action.value.profileName, profileAddress: action.value.profileAddress};
      }
      break;

    case debugActionsType.PROFILE_SETTING_EXPLORER:
      if (action.value) {
        return {...state, profileSettingExplorer: action.value};
      }
      break;

    case debugActionsType.UPDATE_SHOW_PROFILE:
      if (action.value) {
        return {...state, showProfile: action.value};
      }
      break;

    case debugActionsType.UPDATE_LAST_PROFILE_ID_VIEW:
      if (action.value) {
        return {...state, lastProfileIdView: action.value};
      }
      break;

    case debugActionsType.SHOW_ALERT:
      if (action.value) {
        const {alertShow, alertText, alertStyle} = action.value;

        return {
          ...state,
          alertShow,
          alertText: alertText !== undefined ? alertText : initialState.alertText,
          alertStyle: alertStyle !== undefined ? alertStyle : initialState.alertStyle,
        };
      }
      break;

    case debugActionsType.HARDWARE_VALUE: {
      const {pressureSource, pressureBottle, vacuumSource, capacitanceSensor_1, capacitanceSensor_2} = action.value;

      return {
        ...state,
        pressureSource: pressureSource !== undefined ? pressureSource : state.pressureSource,
        pressureBottle: pressureBottle !== undefined ? pressureBottle : state.pressureBottle,
        vacuumSource: vacuumSource !== undefined ? vacuumSource : state.vacuumSource,
        capacitanceSensor_1: capacitanceSensor_1 !== undefined ? capacitanceSensor_1 : state.capacitanceSensor_1,
        capacitanceSensor_2: capacitanceSensor_2 !== undefined ? capacitanceSensor_2 : state.capacitanceSensor_2,
      };
      // if(action.value.alertStyle !== undefined){
      //     state = {...state, alertStyle: action.value.alertStyle,}
      // }
      // break;
    }

    case debugActionsType.GET_SETUP:
      return {
        ...state,
        getSetup: action.value,
      };

    case debugActionsType.GET_STATUS:
      return {
        ...state,
        getStatus: action.value,
      };

    case debugActionsType.GET_OTHER_INFO:
      return {
        ...state,
        getOtherInfo: action.value,
      };

    case debugActionsType.SERIAL_CONNECT:
      return {
        ...state,
        serialConnect: action.value,
      };

    case debugActionsType.ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.value,
      };

    case debugActionsType.SUCCESS_MESSAGE:
      return {
        ...state,
        successMessage: action.value,
      };

    case debugActionsType.FAILURE_MESSAGE:
      return {
        ...state,
        failureMessage: action.value,
      };

    case debugActionsType.WARNING_MESSAGE:
      return {
        ...state,
        warningMessage: action.value,
      };

    case debugActionsType.CLEAR_MESSAGE:
      return {
        ...state,
        clearMessage: action.value,
      };

    case debugActionsType.UPDATE_SENSOR_VALUE:
      return {
        ...state,
        updateSensorValue: action.value,
      };

    case debugActionsType.START_SEQUENCE_DESIGNER:
      return {
        ...state,
        startSequenceDesigner: action.value,
      };

    case debugActionsType.STOP_SEQUENCE_DESIGNER:
      return {
        ...state,
        stopSequenceDesigner: action.value,
      };

    case debugActionsType.PAUSE_SEQUENCE_DESIGNER:
      return {
        ...state,
        pauseSequenceDesigner: action.value,
      };

    case debugActionsType.RESUME_SEQUENCE_DESIGNER:
      return {
        ...state,
        resumeSequenceDesigner: action.value,
      };

    // other info
    case debugActionsType.UPDATE_OTHER_INFO:
      return {
        ...state,
        FirmwareName: action.value.FirmwareName,
        FirmwareVersion: action.value.FirmwareVersion,
        SoftwareName: action.value.SoftwareName,
        Version: action.value.Version,
        Culture: action.value.Culture,
        PublicKeyToken: action.value.PublicKeyToken,
        SoftwareVersion: action.value.SoftwareVersion,
        HostName: action.value.HostName,
        IpAddress: action.value.IpAddress,
      };

    default:
      return state;
  }
  return state;
}
